import React from 'react';
import { Redirect } from 'react-router-dom';
import { logout } from '../actions/authActions';

export default function Logout() {
  logout();

  return <Redirect to="/login" />;
}
